import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

// material-ui
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid } from '@material-ui/core';

// project imports
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import { getGreetingTime } from '../../../views/utilities/Greetings';

// style constant
const useStyles = makeStyles((theme) => ({
    flex: {
        display: 'flex'
    },
    grow: {
        flexGrow: 1
    },
    name: {
        marginLeft: '2px',
        fontWeight: 400
    }
}));

//-----------------------|| MAIN NAVBAR / HEADER ||-----------------------//

const Header = ({ handleLeftDrawerToggle }) => {
    const classes = useStyles();
    const sessionUser = useSelector((state) => state.authReducer.user);

    return (
        <React.Fragment>
            <div className={classes.grow} />

            {/* Pipeline 组件
            <Grid item>
                <Pipeline activeStep={2} />
            </Grid> */}

            <div className={classes.grow} />
            <div className={classes.grow} />

            <Grid item className={classes.flex}>
                <Typography variant='h4'>{getGreetingTime()}</Typography>
                {!!sessionUser ? (
                    <Typography component='span' variant='h4' className={classes.name}>
                        , {sessionUser.firstname}!
                    </Typography>
                ) : '!'}
            </Grid>
            {/* notification & profile */}
            <NotificationSection />
            <ProfileSection />
        </React.Fragment>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
